<template>
  <div id="absent_student">
    <div class="absent_content" v-for="(item, index) in info" :key="item.id">
      <div class="absent_title">{{ schoolName }} {{ item.className }}</div>
      <div class="ansent_kind">
        <div class="absent_kind_stu">姓名</div>
        <div class="absent_kind_sch">详情</div>
      </div>


      <!--学生联系-->
      <div class="absent_stu_info" v-for="(stu_info, idx) in item.dormTodayStatisticsErrors" :key="idx">
        <!--学生姓名-->
        <div class="info_name">
          <span>{{ stu_info.name }}</span>
        </div>


        <!--联系方式-->
        <div class="info_detail">
          <div>床位：{{ stu_info.bedName }}</div>
          <div style="display: flex;align-items: center;">详情：
            {{ ['久进未出', '久出未进', '晚归', '未归', '请假'][stu_info.status] }}
            <span style="color:#70B1FF;font-size: 18px;">{{ stu_info.num ? stu_info.num : 0 }}</span>
            <span style="margin-right: 5px;">天</span>

            <van-button v-if="stu_info.num" hairline type="info" round size="mini"
              @click="handleSignIn(stu_info)">处理为正常</van-button>

          </div>

          <div v-if="stu_info.mobile">联系方式：{{ stu_info.mobile }}</div>

          <div v-if="stu_info.signTime">{{ stu_info.signTime && '最后识别记录：' + formatDate(stu_info.signTime) }} {{
      stu_info.signLocation && stu_info.signLocation }}{{ stu_info.signDirection && ['', '（进）',
      '（出）'][stu_info.signDirection] }}</div>


          <div v-if="stu_info.parentList && stu_info.parentList.length > 0"
            style="color:#70b1ff;width: 100%; font-weight: bold;">家长联系方式</div>

          <!-- 一个家长 -->
          <template v-if="stu_info.parentList && stu_info.parentList.length == 1">
            <div class="tel_div" style="width: 100%;">
              <span v-for="(tel, tel_idx) in stu_info.parentList" :key="tel_idx">
                <span> {{ tel.relationship ? parentList[tel.relationship] + '：' : tel.name }}</span>
                <span v-if="!tel.isShowMobile">{{ tel.mobile }}</span>
                <a v-if="tel.isShowMobile" :href="'tel:' + tel.noMobile">{{ tel.noMobile }}</a>
                <van-icon style="text-indent: 0;font-size: 15px;margin-left: 3px;"
                  @click="getTeacherOrParentMobile(tel, tel.isShowMobile)"
                  v-if="!tel.isShowMobile && tel.name != '该学生未绑定家长'" name="eye-o" />
                <van-icon style="text-indent: 0;font-size: 15px;margin-left: 3px;"
                  @click="getTeacherOrParentMobile(tel, tel.isShowMobile)" v-if="tel.isShowMobile" name="closed-eye" />




              </span>
            </div>
          </template>

          <!-- 多个家长 -->
          <template v-if="stu_info.parentList && stu_info.parentList.length > 1">
            <!-- 第一项 -->
            <div class="tel_div" style="width: 100%;">
              <span v-for="(tel, tel_idx) in [stu_info.parentList[0]]" :key="tel_idx">
                <span> {{ tel.relationship ? parentList[tel.relationship] + '：' : tel.name }}</span>
                <span v-if="!tel.isShowMobile">{{ tel.mobile }}</span>
                <a v-if="tel.isShowMobile" :href="'tel:' + tel.noMobile">{{ tel.noMobile }}</a>
                <van-icon style="text-indent: 0;font-size: 15px;margin-left: 3px;"
                  @click="getTeacherOrParentMobile(tel, tel.isShowMobile)"
                  v-if="!tel.isShowMobile && tel.name != '该学生未绑定家长'" name="eye-o" />
                <van-icon style="text-indent: 0;font-size: 15px;margin-left: 3px;"
                  @click="getTeacherOrParentMobile(tel, tel.isShowMobile)" v-if="tel.isShowMobile" name="closed-eye" />

              </span>
            </div>

            <div style="color: #1989fa;margin-top: 0;" @click="changeShowParent(index, idx, !stu_info.isShowParent)"
              v-if="!stu_info.isShowParent">更多</div>

            <!-- 剩余项 -->
            <div class="tel_div" style="width: 100%;margin-top: 0;" v-if="stu_info.isShowParent">
              <span v-for="(tel, tel_idx) in stu_info.parentList.slice(1)" :key="tel_idx">
                <span> {{ tel.relationship ? parentList[tel.relationship] + '：' : tel.name }}</span>
                <span v-if="!tel.isShowMobile">{{ tel.mobile }}</span>
                <a v-if="tel.isShowMobile" :href="'tel:' + tel.noMobile">{{ tel.noMobile }}</a>
                <van-icon style="text-indent: 0;font-size: 15px;margin-left: 3px;"
                  @click="getTeacherOrParentMobile(tel, tel.isShowMobile)"
                  v-if="!tel.isShowMobile && tel.name != '该学生未绑定家长'" name="eye-o" />
                <van-icon style="text-indent: 0;font-size: 15px;margin-left: 3px;"
                  @click="getTeacherOrParentMobile(tel, tel.isShowMobile)" v-if="tel.isShowMobile" name="closed-eye" />

              </span>
            </div>
          </template>




          <div v-if="stu_info.teacherList && stu_info.teacherList.length > 0"
            style="color:#70b1ff;width: 100%;font-weight: bold;">班主任联系方式</div>

          <!-- 一个老师 -->
          <template v-if="stu_info.teacherList && stu_info.teacherList.length == 1">
            <div style="width: 100%;">
              <div v-for="(tel, tel_idx) in stu_info.teacherList" :key="tel_idx">
                <span v-if="tel.id">{{ tel.name ? `${tel.name}：` : '' }}</span>
                <span v-if="!tel.isShowMobile">{{ tel.mobile }}</span>
                <a v-if="tel.isShowMobile" :href="'tel:' + tel.noMobile">{{ tel.noMobile }}</a>
                <van-icon style="text-indent: 0;font-size: 15px;margin-left: 3px;"
                  @click="getTeacherOrParentMobile(tel, tel.isShowMobile)"
                  v-if="!tel.isShowMobile && tel.name != '该学生未绑定家长'" name="eye-o" />
                <van-icon style="text-indent: 0;font-size: 15px;margin-left: 3px;"
                  @click="getTeacherOrParentMobile(tel, tel.isShowMobile)" v-if="tel.isShowMobile" name="closed-eye" />

              </div>
            </div>
          </template>
          <!-- 多个老师 -->
          <template v-if="stu_info.teacherList && stu_info.teacherList.length > 1">

            <div style="width: 100%;">
              <div v-for="(tel, tel_idx) in [stu_info.teacherList[0]]" :key="tel_idx">
                <span v-if="tel.id">{{ tel.name ? `${tel.name}：` : '' }}</span>
                <span v-if="!tel.isShowMobile">{{ tel.mobile }}</span>
                <a v-if="tel.isShowMobile" :href="'tel:' + tel.noMobile">{{ tel.noMobile }}</a>
                <van-icon style="text-indent: 0;font-size: 15px;margin-left: 3px;"
                  @click="getTeacherOrParentMobile(tel, tel.isShowMobile)"
                  v-if="!tel.isShowMobile && tel.name != '该学生未绑定家长'" name="eye-o" />
                <van-icon style="text-indent: 0;font-size: 15px;margin-left: 3px;"
                  @click="getTeacherOrParentMobile(tel, tel.isShowMobile)" v-if="tel.isShowMobile" name="closed-eye" />

              </div>
            </div>

            <div style="color: #1989fa;margin-top: 0;" @click="changeShowTeacher(index, idx, !stu_info.isClassTeacher)"
              v-if="!stu_info.isClassTeacher">更多
            </div>
            <div style="width: 100%;margin-top: 0;" v-if="stu_info.isClassTeacher">
              <div v-for="(tel, tel_idx) in stu_info.teacherList.slice(1)" :key="tel_idx">
                <span v-if="tel.id">{{ tel.name ? `${tel.name}：` : '' }}</span>
                <span v-if="!tel.isShowMobile">{{ tel.mobile }}</span>
                <a v-if="tel.isShowMobile" :href="'tel:' + tel.noMobile">{{ tel.noMobile }}</a>
                <van-icon style="text-indent: 0;font-size: 15px;margin-left: 3px;"
                  @click="getTeacherOrParentMobile  (tel, tel.isShowMobile)"
                  v-if="!tel.isShowMobile && tel.name != '该学生未绑定家长'" name="eye-o" />
                <van-icon style="text-indent: 0;font-size: 15px;margin-left: 3px;"
                  @click="getTeacherOrParentMobile(tel, tel.isShowMobile)" v-if="tel.isShowMobile" name="closed-eye" />

              </div>
            </div>

          </template>





        </div>


        <!-- <div class="info_detail">
            <span v-for="(tel,tel_idx) in stu_info.parentList" :key="tel_idx"
            >
            <span> {{ tel.relationship ? parentList[tel.relationship] + '：' : tel.name }}</span>
            <a :href="'tel:' + tel.mobile">{{ tel.mobile }}</a>
          </span>
        </div> -->


      </div>
    </div>
    <van-empty v-if="info.length == 0" description="暂无归寝异常数据" />

    <!-- 设置为归寝正常询问弹窗 -->
    <van-dialog v-model="dialogShow" show-cancel-button close-on-click-overlay confirm-button-text="通过"
      title="是否设置该学生归寝正常?" @confirm="confirmApply()">
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: "abnormal-bedtime",
  data() {
    return {
      // 未到校学生信息
      info: [],
      titleInfo: {},
      params: {
        date: '',
        schoolId: '',
        status: ''
      },
      schoolName: JSON.parse(localStorage.getItem('userInfo')).schoolName,
      // 获取老师Id
      teacherId: JSON.parse(localStorage.getItem('userInfo')).id,
      // 待实现
      classId: '', // 根据classId显示各自班级的未到学生清单 ( 待实现 )

      // 当前老师管理的班级列表
      classListIds: [],
      parentList: ['爸爸', '妈妈', '爷爷', '奶奶', '外婆', '外公', '哥哥', '姐姐', '其他亲属', '伯父', '伯母', '叔叔', '婶婶', '姑父', '姑母', '舅舅', '舅妈', '姨夫', '姨妈', '嫂嫂', '姐夫']


      // 审批正常设置弹窗

      , dialogShow: false,
      // 当前选中的学生数据
      nowSelectStu: {},
    };
  },
  created() {
    this.params.schoolId = this.getParams('schoolId')
    this.params.date = this.getParams('date')
    this.params.status = this.getParams('status') == 3 ? 1 : this.params.status
    console.log('this.params', this.params)
    this.getTeacherManage()
    this.getStudentList()
  },
  methods: {
    // 切换展示家长联系方式
    changeShowParent(index, idx, bol) {
      this.$set(this.info[index]['dormTodayStatisticsErrors'][idx], 'isShowParent', bol)
    },
    // 切换展示老师联系方式
    changeShowTeacher(index, idx, bol) {
      this.$set(this.info[index]['dormTodayStatisticsErrors'][idx], 'isClassTeacher', bol)
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    // 获取参数
    getParams(name) {
      console.log(window.location)
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      console.log('r', r)
      return r ? unescape(r[2]) : '';
    },
    handleSignIn(data) {
      this.dialogShow = true
      this.nowSelectStu = data
    },

    async confirmApply() {
      const { data, code, msg } = await this.$https.dormWarningStatusUpdatePlatform({
        id: this.nowSelectStu.id,
      })
      if (code == 200) {
        this.$toast('设置成功')
        this.getStudentList()
      } else {
        this.$toast(msg)
      }
    },
    // 获取当前老师管理的班级
    async getTeacherManage() {
      console.log('获取老师Id', this.teacherId)
      // 根据Id获取管理班级
      const { data, code } = await this.$https.getClassListByTeacherId({
        teacherId: this.teacherId
      })
      if (code == 200) {
        let classIds = []
        // 对返回的数据进行处理
        console.log('data', data)
        function fn(data) {
          data.forEach(item => {
            if (item.children) {
              fn(item.children)
            } else {
              classIds.push(item.id)
            }
          })
        }
        fn(data)
        this.classListIds = classIds
      } else {
        this.classListIds = []
      }
      console.log('data,code', data, code)
    },
    getTeacherOrParentMobile(data, bol) {
      if (!data.noMobile) { // 没有手机号
        this.$https.getMobileById({
          id: data.id
        }).then(res => {
          if (res.code == 200) {

            data.noMobile = res.data
            data.isShowMobile = !bol

          } else {
            this.$toast(res.msg)
          }
        })
      } else { // 有手机号
        data.isShowMobile = !bol
      }
    },

    // 获取归寝数据详情
    async getStudentList() {
      const { data, code } = await this.$https.getDormitoryStatisticsError(this.params)
      if (code == 200 && data) {
        // console.log('获取到数据', data.find(item => item.id == this.classId), this.classId)
        if (this.classId) {
          this.info = [data.find(item => item.id == this.classId)]
        } else {
          console.log('所有班级的归寝异常数据', data, '管理的班级', this.classListIds)
          let newData = []
          data.forEach(item => {
            if (this.classListIds.includes(item.classId) && item.dormTodayStatisticsErrors.length > 0) {
              newData.push(item)
            }
          })

          newData.forEach(x => {
            x.dormTodayStatisticsErrors.forEach(s => {
              s.isShowParent = false
              s.isClassTeacher = false
              if (s.parentList) {
                s.parentList.forEach(parent => {
                  parent.isShowMobile = false
                })
              }
              if (s.teacherList) {
                s.teacherList.forEach(teacher => {
                  teacher.isShowMobile = false
                })
              }
            })
          })
          this.info = newData

        }
      }


    }
  },
};
</script>

<style lang="scss" scope>
.absent_content {
  margin: 0rem 1rem 1rem 1rem;
}

.absent_title {
  background-color: #70B1FF;
  font-size: .8rem
    /* 16/20 */
  ;
  color: #fff;
  line-height: 2rem;
  text-align: center;
}

.ansent_kind {
  height: 1.5rem
    /* 30/20 */
  ;
  display: flex;
  border-left: .05rem
    /* 1/20 */
    solid #ccc;
  border-right: .05rem
    /* 1/20 */
    solid #ccc;
  background-color: #DBEAFF;
}

.absent_kind_stu,
.absent_kind_sch {
  font-size: .9rem
    /* 14/20 */
  ;
  line-height: 1.5rem
    /* 30/20 */
  ;
  text-align: center;
  color: #3E4D61;
}

.absent_kind_stu {
  flex: 1.5;
}

.absent_kind_sch {
  flex: 5;
}

.absent_stu_info {
  width: 100%;
  display: flex;
  border-left: .05rem
    /* 1/20 */
    solid #ccc;
  border-right: .05rem
    /* 1/20 */
    solid #ccc;
}

.info_name {
  flex: 1.5;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: .7rem
    /* 14/20 */
    /* 12/20 */
    /* 14/20 */
  ;
  border-right: .05rem
    /* 1/20 */
    solid #ccc;
  border-bottom: .05rem
    /* 1/20 */
    solid #ccc;
}

.info_detail {
  padding: 0 .5rem
    /* 10/20 */
    .5rem;
  flex: 5;
  flex-wrap: wrap;
  display: flex;
  justify-content: space-between;
  border-bottom: .05rem
    /* 1/20 */
    solid #ccc;
}



.info_detail>div {
  // width: 50%;
  font-size: .8rem
    /* 12/20 */
  ;
  display: block;
  margin-top: .5rem
    /* 10/20 */
  ;
}

.tel_div {
  a {
    font-style: normal;
    color: darkblue;
    text-decoration: none
  }

}

#absent_student {
  padding-bottom: 2rem
    /* 50/20 */
  ;
  padding-top: 1rem;
}
</style>
